import styled from "styled-components";
import {DefaultTextBold, DefaultTextLight} from "components/text/Text";

export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(60%);
  border-radius: 20px;
  background-color: #F1F1F1;
  padding: 20px;
  margin: 0 20px 0 0;
  overflow-x: hidden;
  @media (max-width: 1300px){
    margin: 0 0 20px 0;
    width: calc(100% - 40px);
  }
`

export const SummaryCheckoutIconContainer = styled.div`
  display: flex;
  align-items: center;
  color: #2E3A59;
`

export const SummaryCheckoutCartIcon = styled.i`
  font-size: 20px;
  margin-right: 10px;
`

export const SummaryCheckoutCartText = styled(DefaultTextBold)`
  font-size: 20px;
`

export const SummaryCardSummaryContainer = styled.div`
  display: flex;
  width: 100%;
  height: 40vh;
  margin: 20px 0;
  @media (max-width: 600px){
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 500px;
  }
`

export const SummaryCheckoutCardContainer = styled.div`
  display: flex;
  height: 100%;
  width: 50%;

  @media (max-width: 600px){
    width: 90%;
    height: 60%;
    margin-bottom: 30px;
  }
`

export const SummaryCheckoutPlanInfoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1;
  color: #2E3A59;
  @media (max-width: 600px){
    width: 90%;
  }
`

export const SummaryCheckoutPlanInfo = styled.div`
  display: flex;
  flex-direction: column;
  height: 90%;
  justify-content: space-between;
  margin-left: 10px;

  @media (max-width: 600px){
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    row-gap: 20px;
  }
`

export const SummaryCheckoutPlanInfoTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const SummaryCheckoutPlanInfoHeader = styled(DefaultTextBold)`
  font-size: 20px;
  color: rgba(46, 58, 89, 0.66);
  letter-spacing: 4px;

  @media (max-width: 1300px) {
    font-size: 18px;
  }
  
  @media (max-width: 900px) {
    font-size: 15px;
  }
`

export const SummaryCheckoutPlanInfoName = styled(DefaultTextBold)`
  font-size: 25px;

  @media (max-width: 1300px) {
    font-size: 22px;
  }

  @media (max-width: 900px) {
    font-size: 20px;
  }
`

export const SummaryCheckoutPlanInfoType = styled(DefaultTextLight)`
  font-size: 20px;

  @media (max-width: 1300px) {
    font-size: 18px;
  }

  @media (max-width: 900px) {
    font-size: 16px;
  }
`

export const SummaryCheckoutPlanInfoPriceContainer = styled.div`
  display: flex;
`

export const SummaryCheckoutPlanInfoPrice = styled(DefaultTextBold)`
  font-size: 20px;

  @media (max-width: 1300px) {
    font-size: 18px;
  }

  @media (max-width: 900px) {
    font-size: 16px;
  }
`

export const SummaryCheckoutPlanInfoTime = styled(DefaultTextLight)`
  font-size: 20px;

  @media (max-width: 1300px) {
    font-size: 18px;
  }

  @media (max-width: 900px) {
    font-size: 16px;
  }
`

export const SummaryCheckoutPlanInfoDisclaimer = styled.p`
  font-size: 12px;
  
  @media (max-width: 900px) {
    font-size: 10px;
  }
`

export const SummaryCheckoutPlanInfoChangePlan = styled.p`
  font-size: 18px;
  text-decoration: underline;
  cursor: pointer;
  
  @media (max-width: 900px) {
    font-size: 15px;
  }
`

export const SummarySubscriptionContainer = styled.div`
  display: flex;
  flex: 1;
`

export const SummarySubscriptionIcon = styled.i`
  
`

export const SummarySubscriptionText = styled.p`

`

export const SummaryIconContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 2vh;
  color: #2E3A59;
  margin-top: 2vh;
`

export const SummaryIcon = styled.i`
  margin-right: 10px;
  font-size: 2.5vh;
`

export const SummaryIconText = styled(DefaultTextBold)`
  font-size: 2.5vh;
`

export const SummaryPaymentDetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex: 1;
  margin-top: 4vh;
`
